import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useBooking } from "@/context/BookingContext";
import { EnquiryForm } from "@/components/EnquiryForm";

export const BookingModal = () => {
  const { open, setOpen, treatment } = useBooking();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        data-testid="booking-modal"
        className="max-h-[90vh] overflow-y-auto border-white/60 bg-[#FFFDF9]/95 backdrop-blur-xl sm:max-w-lg"
      >
        <DialogHeader>
          <p className="eyebrow">Private Consultation</p>
          <DialogTitle className="font-serif text-3xl font-semibold text-[#1A1615]">
            Begin Your Skin Journey
          </DialogTitle>
          <DialogDescription className="text-sm font-light text-[#5A504B]">
            Share a few details and our concierge team will arrange your consultation within 24 hours.
          </DialogDescription>
        </DialogHeader>
        <EnquiryForm prefix="booking" initialTreatment={treatment} onSuccess={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  );
};
